var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasStar = function SvgChristmasStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.236 1.422 8.68 5.238h2.813a.69.69 0 0 1 .485 1.203L9.542 8.143l1.349 3.107a.737.737 0 0 1-1.05.92l-3.268-1.839-3.268 1.839a.737.737 0 0 1-1.055-.92l1.357-3.107-2.44-1.702a.688.688 0 0 1 .483-1.203h2.813l1.443-3.816a.75.75 0 0 1 1.33 0m6.284 8.891 7.574 3.61a.352.352 0 0 1-.083.663l-5.994 1.199v5.192a.352.352 0 0 1-.641.198l-4.5-6.576"
  })));
};
export default SvgChristmasStar;